import { PublicPageTemplate } from "./PublicPageTemplate";

const SolutionFinancementPage = () => (
  <PublicPageTemplate
    badge="Solution Financement"
    title="Trouvez votre"
    highlight="financement"
    description="Identification automatique des aides, subventions et financements adaptés à votre projet grâce à l'IA."
  />
);
export default SolutionFinancementPage;
